import moment from 'moment';

/**
 * Dates and times on paper.
 *
 * The formats are the ones each document has always used — this module exists
 * only to fix WHICH moment they render, not how it looks.
 *
 * Order dates are written by whichever client placed the order, as a naive
 * local wall-clock string with no timezone on it. The server reads that as UTC
 * and stores the instant three hours early. Reading it back with `moment.utc`
 * undoes exactly that, and prints the time that was actually meant — the same
 * thing `formatRowDateTime` does for the orders list, so paper and screen
 * agree.
 *
 * Reading it with plain `moment()` would apply the browser's offset a second
 * time and print three hours out, which is what the receipts were doing.
 */

/** A value that will parse, so nothing ever prints "Invalid date". */
const safe = (value) => (moment(value).isValid() ? value : new Date());

/** `Sep 09, 2026` — the receipt's date cell. */
export const paperDate = (value) => moment.utc(safe(value)).format('MMM DD, YYYY');

/** `05:53 PM` — the receipt's time cell. */
export const paperTime = (value) => moment.utc(safe(value)).format('hh:mm A');

/** `09/09/2026  05:53 PM` — the kitchen ticket's footer, on one line. */
export const paperStamp = (value) =>
  moment.utc(safe(value)).format('DD/MM/YYYY  hh:mm A');

/**
 * The same shape, but the wall clock.
 *
 * Only the test slip uses this. Its job is "is this machine alive and is this
 * print fresh", so it has to agree with the clock on the wall rather than with
 * a stored order date.
 */
export const localStamp = () => moment().format('DD/MM/YYYY  hh:mm A');
